import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { DateInput } from '../../../../components/form-elements/DateInput';
import { OrderErrorsReportDocument } from '../../../../models/production/order-errors-report-document';

export const OrderErrorsReport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setStartDate(new Date());
        setIsOpen(false);
    };

    /**
     * Handler for changing the start date.
     * @param newDate The new start date as chosen 
     */
    const onStartDateChange = (newDate: Date) => {
        setStartDate(newDate);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        if (startDate) {
            const req = new OrderErrorsReportDocument(startDate);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Order Errors Report</h3>
                                <p>Get a list of recent orders that had errors during processing.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Order Errors report</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p>Provide a start date to search</p>
                        </div>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-auto">
                            <DateInput
                                id="endDate"
                                label="Start Date"
                                value={startDate}
                                onChange={onStartDateChange}
                                inline={true}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="windloadReportNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="windloadReportYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
